/*
 * Polish 1 — Ghost section typography.
 *
 * Drops a giant Cormorant watermark (.elome-ghost-text) behind each major
 * section. Decorative only: aria-hidden, and pointer-events:none / user-select:
 * none in elome-effects.css, so it never blocks clicks or selection. Skipped in
 * the theme editor (designMode) so it can't interfere with section editing.
 * Idempotent via a data-flag (safe on bfcache / re-run).
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  function injectGhost(el, word, addClass) {
    if (!el || el.dataset.elomeGhost || !word) return;
    el.dataset.elomeGhost = '1';
    if (addClass !== false) el.classList.add('elome-has-ghost');
    var span = document.createElement('span');
    span.className = 'elome-ghost-text';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = word;
    el.insertBefore(span, el.firstChild);
  }

  function run() {
    // One ghost per section. NOTE: Dawn's featured collection has no
    // `.featured-collection` class, so the homepage Launch section is matched by
    // its JSON-template id instead.
    var MAP = [
      { sel: '.banner', word: 'ELOMÉ' },
      { sel: '#shopify-section-featured_collection', word: 'LAUNCH' },
      { sel: '.elome-manifesto__hero', word: 'MANIFESTO' },
      { sel: '.elome-lookbook__hero', word: 'LOOKBOOK' },
    ];
    MAP.forEach(function (entry) {
      injectGhost(document.querySelector(entry.sel), entry.word, true);
    });

    // Editorial spread — one ghost per panel, using its eyebrow (else ELOMÉ).
    document.querySelectorAll('.elome-editorial__panel').forEach(function (panel) {
      var eyebrow = panel.querySelector('.elome-editorial__eyebrow');
      var word = eyebrow && eyebrow.textContent.trim();
      injectGhost(panel, word || 'ELOMÉ', true);
    });

    // Collection swipe — inject into the sticky PIN (it already has
    // overflow:hidden + a positioning context). Injecting into the section and
    // forcing position:relative/overflow there would break the sticky pin.
    injectGhost(
      document.querySelector('.elome-swipe--jack .elome-swipe__pin'),
      'THE EDIT',
      false
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/*
 * Polish 2 — Brutalist square navigation (homepage only).
 *
 * A fixed column of 5px squares on the right edge, one per major section. The
 * most-visible section's square fills; hover shows a tooltip; click Lenis-
 * scrolls to that section. Hidden on mobile and over open Dawn overlays (CSS).
 * Not built off the homepage, or when fewer than 3 of its sections exist.
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-index')) return;
  if (!('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SECTIONS = [
    { name: 'Hero', sel: '.banner' },
    { name: 'New Arrivals', sel: '[id$="__featured_collection"]' },
    { name: 'Our collection', sel: '.elome-swipe' },
    { name: 'Editorial spread', sel: '.elome-editorial' },
    { name: 'Footer', sel: '.footer' },
  ];

  function build() {
    var items = [];
    SECTIONS.forEach(function (s) {
      var el = document.querySelector(s.sel);
      if (!el) return;
      items.push({ name: s.name, target: el.closest('.shopify-section') || el });
    });
    if (items.length < 3) return; // not enough to navigate

    function indexOfTarget(t) {
      for (var k = 0; k < items.length; k++) {
        if (items[k].target === t) return k;
      }
      return -1;
    }

    var nav = document.createElement('nav');
    nav.className = 'elome-squarenav';
    nav.setAttribute('aria-label', 'Section navigation');

    items.forEach(function (item) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'elome-squarenav__dot';
      dot.setAttribute('aria-label', item.name);

      var tip = document.createElement('span');
      tip.className = 'elome-squarenav__tip';
      tip.textContent = item.name;
      dot.appendChild(tip);

      dot.addEventListener('click', function () {
        var header = document.querySelector('.header-wrapper');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        var destination = Math.max(0, window.scrollY + item.target.getBoundingClientRect().top - headerHeight);
        if (window.elomeLenis && !reduce) {
          window.elomeLenis.scrollTo(destination, { duration: 1.1 });
        } else {
          window.scrollTo({ top: destination, behavior: reduce ? 'auto' : 'smooth' });
        }
      });

      item.dot = dot;
      nav.appendChild(dot);
    });

    document.body.appendChild(nav);

    var ratios = new Array(items.length);
    for (var r = 0; r < ratios.length; r++) ratios[r] = 0;
    var activeIdx = -1;

    function refresh() {
      // Most-visible section wins, with a 0.4 floor to avoid flicker.
      var best = -1;
      var bestRatio = 0.4;
      for (var i = 0; i < ratios.length; i++) {
        if (ratios[i] >= bestRatio) {
          bestRatio = ratios[i];
          best = i;
        }
      }
      if (best < 0 || best === activeIdx) return;
      activeIdx = best;
      items.forEach(function (item, i) {
        item.dot.classList.toggle('is-active', i === best);
      });
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var i = indexOfTarget(entry.target);
          if (i < 0) return;
          ratios[i] = entry.isIntersecting ? entry.intersectionRatio : 0;
        });
        refresh();
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
    );

    items.forEach(function (item) {
      io.observe(item.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();

/*
 * Polish 4 — Image tilt on hover (desktop pointer only; gated on reduced motion).
 *
 * A subtle ±4° 3D tilt that follows the cursor and springs back on leave.
 *
 * Dawn nests the product/collection image two levels down
 * (.card__media › .media › img). CSS `perspective` only reaches DIRECT children,
 * and the intervening `.media` is `transform-style: flat`, so an earlier version
 * (perspective on .card__media, transform on the nested <img>) flattened the 3D
 * space and produced NO visible tilt on collection-page cards. Fix: tilt the
 * `.media` block itself — it's the direct child of `.card__media` (so perspective
 * reaches it) and contains the primary, secondary and swatch images, which then
 * tilt as one unit. Stories thumbs nest the image directly, so there the <img>
 * (`.elome-stories__img`) is the tilt element, with perspective on its thumb.
 *
 * Each SEL entry matches the element to TRANSFORM; perspective goes on its parent.
 * A MutationObserver re-binds cards inserted later (facet filtering / infinite
 * scroll replace the grid via AJAX); bind() is idempotent so re-scans are cheap.
 */
(function () {
  'use strict';

  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAX_DEG = 4;
  // `.card__media .media` covers product AND collection cards; the others cover
  // the élome stories thumbnails and any collection card not using `.card__media`.
  var SEL = '.card__media .media, .elome-stories__img, .collection-card-wrapper .media';

  function clampDeg(v) {
    if (v > MAX_DEG) return MAX_DEG;
    if (v < -MAX_DEG) return -MAX_DEG;
    return v;
  }

  function bind(tiltEl) {
    if (tiltEl.classList.contains('elome-tilt-img')) return; // already wired
    var stage = tiltEl.parentElement;
    if (!stage) return;

    stage.classList.add('elome-tilt'); // perspective: 600px (elome-effects.css)
    tiltEl.classList.add('elome-tilt-img');

    stage.addEventListener('mousemove', function (e) {
      var rect = stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var rotY = clampDeg(((e.clientX - rect.left) / rect.width - 0.5) * 8);
      var rotX = clampDeg(-((e.clientY - rect.top) / rect.height - 0.5) * 8);
      tiltEl.style.transition = 'none';
      tiltEl.style.transform =
        'rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale(1.02)';
    });

    stage.addEventListener('mouseleave', function () {
      tiltEl.style.transition = 'transform 0.4s ease';
      tiltEl.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
    });
  }

  function run() {
    document.querySelectorAll(SEL).forEach(bind);
  }

  // Re-bind after dynamic grid updates (Dawn facet filtering / pagination swap
  // the product grid). Debounced to once per frame; bind() skips wired elements.
  var scheduled = false;
  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scheduleRun();
        return;
      }
    }
  });

  function start() {
    run();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
